export default __webpack_public_path__ + "static/edith-d74621ba0d9e062d118e8947ce7e3b74.png";